import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { NavigationService } from '../../services/navigation.service';
import { NotificationService } from '../../services/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ErrorHandlerService } from '../../services/error-handler.service';

@Component({
    selector: 'fp-linkedin-callback',
    templateUrl: './linkedin-callback.component.html',
    styleUrl: './linkedin-callback.component.scss',
    standalone: false
})
export class LinkedinCallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private navigation: NavigationService,
    private notificationService: NotificationService,
    private translate: TranslateService,
    private router: Router,
    private errorHandler: ErrorHandlerService
  ) {}
  signup: boolean = false;
  private dlAuthErrorStorageKey = 'dlSignupAuthError';

  async ngOnInit(): Promise<void> {
    const code = this.route.snapshot.queryParamMap.get('code');
    const state = this.route.snapshot.queryParamMap.get('state');
    const error = this.route.snapshot.queryParamMap.get('error');
    const storedState = sessionStorage.getItem('linkedinState');
    const deeplinkId = sessionStorage.getItem('authDeeplink');
    this.signup = sessionStorage.getItem('linkedinSignup') === 'true';

    if (!code || !state || state !== storedState || error) {
      const msg = this.translate.instant('AUTH.LINKEDIN_LOGIN.FAILED');
      this.notificationService.openSnackBar('error', msg);
      if (deeplinkId) {
        sessionStorage.setItem(this.dlAuthErrorStorageKey, msg);
        await this.router.navigate(['/auth/dlsignup'], { queryParams: { uuid: deeplinkId } });
      } else {
        await this.router.navigate(['/users/login'], { state: { snackbarError: error } });
      }
      return;
    }

    sessionStorage.removeItem('linkedinState');
    sessionStorage.removeItem('linkedinSignup');
    sessionStorage.removeItem('authDeeplink');

    try {
      await this.handleLinkedinLoginSuccess(code, deeplinkId);
    } catch (error) {
      const backendMessage =
        error?.error?.error || // our BE often returns { error: "..." }
        error?.error?.detail ||
        error?.error ||
        error?.message;
      const translated = this.errorHandler.translateError(backendMessage);
      this.notificationService.openSnackBar('error', translated);
      if (deeplinkId) {
        sessionStorage.setItem(this.dlAuthErrorStorageKey, backendMessage);
        await this.router.navigate(['/auth/dlsignup'], { queryParams: { uuid: deeplinkId } });
      } else {
        await this.router.navigate(['/users/login'], { state: { snackbarError: error.error } });
      }
      return;
    }
  }

  private async handleLinkedinLoginSuccess(code: any, deeplinkId?: string | null): Promise<void> {
    const user = await this.authService.socialLogin('linkedin_oauth2', code, this.signup, deeplinkId);
    if (user) {
      this.notificationService.openSnackBar(
        'success',
        this.signup
          ? this.translate.instant('AUTH.LINKEDIN_LOGIN.SIGNUP_SUCCESS')
          : this.translate.instant('AUTH.LINKEDIN_LOGIN.LOGIN_SUCCESS')
      );
      await this.navigation.processLogin(user.role);
    }
  }
}
